import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Lock, CreditCard } from 'lucide-react';
interface ComboCardProps {
  title: string;
  price: string;
  originalPrice?: string;
  priceUSD?: string;
  value?: number;
  features: string[];
  description: string;
  isRecommended?: boolean;
  isPremium?: boolean;
  onBuy: () => void;
  image?: string;
  checkoutUrl: string;
}
export function ComboCard({
  title,
  price,
  originalPrice,
  priceUSD,
  features,
  description,
  isRecommended = false,
  isPremium = false,
  onBuy,
  image,
  checkoutUrl
}: ComboCardProps) {
  const handleBuy = () => {
    onBuy();
    window.location.href = checkoutUrl;
  };
  return <motion.div whileHover={{
    y: -5
  }} className={`relative flex flex-col rounded-2xl overflow-hidden transition-all duration-300 h-full
        ${isRecommended ? 'border-2 border-yellow-400 bg-black shadow-[0_0_30px_rgba(250,204,21,0.15)] scale-100 md:scale-105 z-10' : isPremium ? 'border border-gray-700 bg-gray-900/80' : 'border border-gray-800 bg-black'}
      `} data-id="element-2">
      {isRecommended && <div className="absolute top-0 left-0 right-0 bg-yellow-400 text-black text-center py-1 font-bold text-sm uppercase tracking-wider z-20" data-id="element-3">
          Más Vendido
        </div>}

      <div className={`p-6 flex-1 flex flex-col ${isRecommended ? 'pt-10' : ''}`} data-id="element-4">
        {/* Header Image */}
        {image && <div className="h-48 mb-6 flex items-center justify-center p-2" data-id="element-5">
            <img src={image} alt={title} className="h-full object-contain drop-shadow-2xl" data-id="element-6" />
          </div>}

        {/* Title */}
        <div className="text-center mb-6" data-id="element-7">
          <h3 className={`text-2xl font-bold mb-2 ${isRecommended ? 'text-yellow-400' : 'text-white'}`} data-id="element-8">
            {title}
          </h3>
          <p className="text-gray-400 text-sm mt-2 min-h-[40px]" data-id="element-9">
            {description}
          </p>
        </div>

        {/* Features */}
        <ul className="space-y-3 mb-8 flex-1" data-id="element-10">
          {features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-11">
              <div className={`mt-1 flex-shrink-0 rounded-full p-0.5 ${isRecommended ? 'bg-yellow-400/20' : 'bg-gray-800'}`} data-id="element-12">
                <Check className={`w-3 h-3 ${isRecommended ? 'text-yellow-400' : 'text-gray-400'}`} data-id="element-13" />
              </div>
              <span className="text-gray-300 text-sm leading-snug" data-id="element-14">
                {feature}
              </span>
            </li>)}
        </ul>

        {/* Price + CTA */}
        <div className="text-center mb-2" data-id="element-15">
          {originalPrice && <span className="text-gray-500 text-lg line-through" data-id="element-16">
              USD ${originalPrice}
            </span>}
          <div className="flex items-center justify-center gap-1" data-id="element-17">
            <span className="text-4xl font-bold text-white tracking-tight" data-id="element-18">
              USD ${price}
            </span>
          </div>
          <p className="text-gray-500 text-xs mt-2" data-id="element-19">
            💳 Puedes pagar en tu moneda local — no es necesario pagar con USD
          </p>
        </div>

        <button onClick={handleBuy} className={`w-full py-4 px-6 rounded-xl font-bold text-lg transition-all duration-200 shadow-lg transform active:scale-95 mt-4
            ${isRecommended ? 'bg-yellow-400 text-black hover:bg-yellow-300 shadow-yellow-400/20' : 'bg-white text-black hover:bg-gray-100'}
          `} data-id="element-20">
          Comprar Ahora
        </button>

        {/* Trust Badges */}
        <div className="mt-6 pt-6 border-t border-gray-800 grid grid-cols-3 gap-2 text-center" data-id="element-21">
          <div className="flex flex-col items-center gap-1" data-id="element-22">
            <Shield className="w-4 h-4 text-gray-500" data-id="element-23" />
            <span className="text-[10px] text-gray-500" data-id="element-24">Garantía</span>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-25">
            <Lock className="w-4 h-4 text-gray-500" data-id="element-26" />
            <span className="text-[10px] text-gray-500" data-id="element-27">Seguro</span>
          </div>
          <div className="flex flex-col items-center gap-1" data-id="element-28">
            <CreditCard className="w-4 h-4 text-gray-500" data-id="element-29" />
            <span className="text-[10px] text-gray-500" data-id="element-30">Acceso Ya</span>
          </div>
        </div>
      </div>
    </motion.div>;
}